export default function isFirstConnexion(){
    var isFirstConnexion = window.localStorage.getItem('userFirstConnexion');
    //console.log(isFirstConnexion)
    if(isFirstConnexion === 'true' ){
        return true;
    }else{
        return false;
    }
    
}